import angular from 'angular';
import SignalRService from '@/shared/services/SignalRService';

angular
  .module('cxSettings')
  .controller('AddSubTaskTemplateDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    '$timeout',
    'resourceFactorySvc',
    'templateHttpSvc',
    'dataCache',
    'translateListFilter',
    'enumCacheSvc',
    'dialogsSvc',
    'close',
    'taskTemplate',
    'resources',
    addSubTaskTemplateDialogCtrl,
  ]);

function addSubTaskTemplateDialogCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  $timeout,
  resourceFactorySvc,
  templateHttpSvc,
  dataCache,
  translateListFilter,
  enumCacheSvc,
  dialogsSvc,
  close,
  taskTemplate,
  resources,
  mailTemplates,
) {
  var vm = this;
  vm.showValidation = false;
  vm.saving = false;
  vm.taskTemplate = taskTemplate;
  vm.translation = {};
  vm.subtask = {
    name: '',
    resourceId: null,
    defaultDuration: null,
    deadlineDeviation: null,
    type: 0,
    assignedType: 0,
    userId: null,
    profile: null,
  };
  vm.mailTemplates = mailTemplates;
  vm.assignedTo = {
    assignedType: 0,
    userId: null,
    profile: null,
  };

  vm.resources = resources;
  if (!vm.resources) {
    resourceFactorySvc.get('resource').reg(
      {
        type: 0,
      },
      function(data) {
        vm.resources = data.map(x => ({
          ...x,
          code: x.code | '',
          label: resourceNameFilter(x),
        }));
      },
    );
  }
  if (!vm.mailTemplates) {
    templateHttpSvc.getTemplates(11).then(function(data) {
      vm.mailTemplates = data;
    });
  }

  vm.taskTypeChanged = function() {
    if (vm.subtask.type === 3 || vm.subtask.type === 4) {
      vm.subtask.resourceId = null;
    } else {
      vm.subtask.mailTemplateId = null;
    }
  };

  vm.users = dataCache
    .getArray('user')
    .filter(x => x.isActive || !x.hidden)
    .map(function(user) {
      return {
        id: user.userID,
        label: `${user.firstName} ${user.lastName}`,
        isActive: user.isActive,
      };
    })
    .sortByProperty('name');

  vm.profiles = [];
  enumCacheSvc.get('employeeprofile').then(function(data) {
    vm.profiles = data.map(({ key, value }) => ({
      id: key,
      value,
      label: translateListFilter(key, 'employeeprofile', value),
    }));
  });

  vm.assignedToChanged = function() {
    angular.extend(vm.subtask, vm.assignedTo);
  };

  vm.updateName = function(value) {
    vm.subtask.name = value;
  };
  var handleSuccess = data => {
    if (data && data.countPlannedTasksUpdated) {
      flySvc.proposal('msgPropogateTaskTemplateChangesCount', null, null, null, null, {
        count: data.countPlannedTasksUpdated,
      });
    } else {
      flySvc.success();
    }
    $element.modal('hide');
    close(data, 500);
    vm.saving = false;
    return false;
  };
  vm.save = function() {
    if ($scope.form.$invalid || vm.saving) return;
    vm.saving = true;
    dialogsSvc
      .showYesNoCancel(
        'msgConfirmPropogateTemplateChangesTitle',
        'msgConfirmPropogateTemplateChanges',
      )
      .then(function(result) {
        if (result === null) {
          vm.saving = false;
          return false; // Cancel changes
        }
        vm.subtask.propogateTemplateChanges = !!result;

        $http
          .post(appUrls.tasks + '/api/tasktemplates/templates/' + taskTemplate.id, vm.subtask)
          .then(
            function({ data = {} }) {
              if (data && data.id && vm.translation && vm.translation.save) {
                return vm.translation.save(data.id).then(function() {
                  return handleSuccess(data);
                });
              } else {
                return handleSuccess(data);
              }
            },
            function(error) {
              flySvc.error(error.data.code, error.data.parameters);
              vm.saving = false;
            },
          );
      });
  };

  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };

  vm.cancel = function() {
    close(null, 500);
  };

  const emailTemplateCreatedHandler = emailTemplate => {
    if (emailTemplate.context === 11) {
      if (!vm.mailTemplates) {
        $timeout(function() {
          vm.mailTemplates = [emailTemplate];
        }, 100);
      } else {
        $timeout(function() {
          vm.mailTemplates.push(emailTemplate);
        }, 100);
      }
    }
  };

  SignalRService.subscribe('emailTemplateCreated', emailTemplateCreatedHandler);
}
